module.exports = __webpack_public_path__ + "media/images/xc-31256a4f875cfdfbc43aa844b97d9903.png";